$(document).ready(function () {

  $('#impersonate').ready(function () {
    $('#clear').on('click', function () {
      $('.dropdown').dropdown('clear');
    });
  });

});
